import axios from 'axios';
import { getDomainOrigin, getAxiosConfig } from 'utils/serverConfig';
import type { WalletLedgerApiResponse } from './constants/api.types';

interface IApiResponse<T> {
    status: boolean;
    data: T | null;
    statusCode?: number;
}

export const getProductsByPartnerId = async (
    partnerId: string,
    groupName: string
): Promise<IApiResponse<any>> => {
    try {
        const { status, data } = await axios(
            `${getDomainOrigin()}/api/mpos/partner/${partnerId}/user/wallet/products?group_name=${groupName}`,
            {
                method: 'GET',
                ...getAxiosConfig(),
            }
        );

        return {
            status: status === 200,
            data: data ?? null,
            statusCode: status,
        };
    } catch (e: any) {
        return {
            status: false,
            data: null,
            statusCode: e?.response?.status || 500,
        };
    }
};

export const getWalletLedger = async (
    partnerId: string,
    params: {
        page?: number;
        startTime?: string;
        endTime?: string;
        productId?: string;
        txnAggLevel?: 'day' | 'month';
        walletUserId?: string;
    },
    groupName?: string
): Promise<IApiResponse<WalletLedgerApiResponse>> => {
    try {
        const { status, data } = await axios(
            `${getDomainOrigin()}/api/mpos/partner/${partnerId}/user/wallet/transactions-summary?group_name=${groupName}`,
            {
                method: 'POST',
                data: {
                    page: params.page ?? 1,
                    product_id: params.productId,
                    start_time: params.startTime,
                    end_time: params.endTime,
                    txn_agg_level: params.txnAggLevel,
                    wallet_user_id: params.walletUserId,
                },
                ...getAxiosConfig(),
            }
        );

        if (status === 200) {
            return {
                status: true,
                data: data ?? null,
                statusCode: status,
            };
        }

        return {
            status: false,
            data: null,
            statusCode: status,
        };
    } catch (e: any) {
        return {
            status: false,
            data: null,
            statusCode: e?.response?.status || 500,
        };
    }
};
